import { useQuery } from '@tanstack/react-query'
import { StorageKey } from '@/client/types'
import { getBranches } from '@/infra/services'
export const useGetBranches = (locale: string = 'en') =>
  useQuery({
    queryKey: [StorageKey.BRANCHES, locale],
    queryFn: () => getBranches(locale),
    refetchOnWindowFocus: false
  })
